import React from 'react';
import './Counter.scss';

const Counter = ({ string }: { string: string }): JSX.Element => {
  return <div className="counter">{string.length}</div>;
};

export default Counter;
